import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { StyledQuestionItem } from './index.style';

const AnswerItem = ({ answer, selected, onSelect }) => {
  const { i18n } = useTranslation();
  const { language } = i18n;
  const handleSelectBank = () => {
    onSelect(answer);
  };

  return (
    <StyledQuestionItem selected={selected} onClick={handleSelectBank}>
      <div className="container-icon">
        <img src={answer && answer?.icon} alt="i" className="icon" />
      </div>
      <Box>
        <Typography className="name">
          {answer?.title?.[language || 'vi']}
        </Typography>
        {!!answer?.desc && (
          <Typography className="answer-desc">
            {answer?.desc?.[language || 'vi']}
          </Typography>
        )}
      </Box>
    </StyledQuestionItem>
  );
};

export default AnswerItem;
